import { lazy, Suspense, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import PageContainer from '../container/PageContainer';
import Spinner from '../material-ui/spinner/Spinner';
import ShowContainer from '../material-ui/ShowContainer';
import ErrorBoundary from '../material-ui/error_boundary/ErrorBoundary';
import { Box, Stack } from '@mui/material';
import CusLink from '../material-ui/CusLink';
const GroupBreadcrumb = lazy(() => import('./GroupBreadcrumb'));

export default function CusPageContainer({
  children,
  loader,
  title = '',
  backText,
  backLink,
  urlById,
  description,
  group
}) {
  const { search } = useLocation();

  const prevUrl = useMemo(() => {
    const searchParam = new URLSearchParams(search);
    return searchParam.get('prev');
  }, [search]);

  const getBackInfo = (url) => {
    if (!url) return undefined;
    if (url.search('bonuses/freespin') > 0) {
      return { backLink: url, backText: 'back to bonuses' };
    }

    return undefined;
  };

  const backInfo = getBackInfo(prevUrl);

  return (
    <PageContainer title={title} description={description}>
      <ShowContainer condition={!loader} plug={<Spinner />}>
        <ErrorBoundary>
          <Suspense>
            <ShowContainer condition={group}>
              <Box pb={2}>
                <GroupBreadcrumb group={group} title={title} urlById={urlById} />
              </Box>
            </ShowContainer>
          </Suspense>
        </ErrorBoundary>
        <Box spacing={0} gap={1} display={'flex'} flexDirection={'column'}>
          <ShowContainer condition={backLink && backInfo}>
            <Stack spacing={0} gap={0.5} display={'flex'} flexDirection={'column'}>
              {backLink && <CusLink fontSize={16} mb={2} to={backLink} text={backText} />}

              {backInfo && (
                <CusLink fontSize={14} mb={2} to={backInfo?.backLink} text={backInfo?.backText} />
              )}
            </Stack>
          </ShowContainer>

          {children}
        </Box>
      </ShowContainer>
    </PageContainer>
  );
}
